import rejectOfferReasonAdd from "@/views/rejectOfferReason/rejectOfferReasonAdd";
import rejectOfferReasonList from "@/views/rejectOfferReason/rejectOfferReasonList";
import rejectOfferReasonEdit from "@/views/rejectOfferReason/rejectOfferReasonEdit";


const routes = [
 {
    path: '/rejectOfferReason/Add',
    name: 'rejectOfferReasonAdd',
    component: rejectOfferReasonAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/rejectOfferReason/List',
    name: 'rejectOfferReasonList',
    component: rejectOfferReasonList,
    meta:{requiredAuth:true}
  },
 {
    path: '/rejectOfferReason/Edit/:id',
    name: 'rejectOfferReasonEdit',
    component: rejectOfferReasonEdit,
    meta:{requiredAuth:true}
  },
]

export default routes